import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    DELETE_USER: (userId) => ({ userId }),
    API: {
      DELETE_USER: apiResourceActionCreator('deletedUser')
    }
  }
})

export const apiAction = (authToken, payload) => commonApiActions.authenticated.delete(`${API_ENDPOINT}/user/${payload.userId}`, authToken, actions.admin.api.deleteUser);

function* deleteUser(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload));
}

const configuration = {
  name: 'deleteUser',
  action: actions,
  sagas: deleteUser,
  reducers: {
    request: (state, action) => ({
      ...state,
      isDeletingUser: true,
      error: null
    }),
    success: (state, action) => {
      const deletedUser = action.payload.deletedUser
      return ({
        ...state,
        isDeletingUser: false,
        userData: {
          ...state.userData,
          result: fp.filter(
            (existing) => existing.user.id !== deletedUser.id
          )(state.userData.result)
        },
        businessUserData: {
          ...state.businessUserData,
          result: fp.filter(
            (existing) => existing.user.id !== deletedUser.id
          )(state.businessUserData.result)
        }
      })
    },
    failed: (state, action) => ({
      ...state,
      isDeletingUser: false,
      error: action.payload.error,
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/deleteUser.js